import {useRef} from "react";
import DrawerHandler from "@app/component/overlays/drawer/DrawerHandler";

const useDrawer = () => {

    const drawer = useRef<DrawerHandler>(null);

    const open = () => {
        drawer.current!.open();
    }

    const close = () => {
        drawer.current!.close();
    }

    return {
        ref: drawer,
        open: open,
        close: close,
        isOpen: !!drawer.current && drawer.current.isOpen
    }
}

export default useDrawer;